<template>
	<vs-popup
		:title="$t('indicateRefundReason')"
		class="primary-popup set-ticket-failed"
		:active.sync="activeProp"
	>
		<ul class="leftx set-ticket-failed__list">
			<li v-for="(item, index) in enabledFailReasons" :key="index">
				<vs-radio
					v-model="reason"
					:vs-value="item.id"
					class="set-ticket-failed__item"
				>
					{{ item.name }}
				</vs-radio>
			</li>
		</ul>
		<div class="mt-3 px-2">
			<vs-input
				:label="$t('sumOfRefunds')"
				v-model="reward"
				class="reward-input"
			/>
		</div>
		<div class="set-ticket-failed__controls">
			<vs-button :disabled="!reason || isReward" class="mr-1" color="primary" @click="confirm">{{
				$t("save")
			}}</vs-button>

			<vs-custom-button @click="close" color="#9a9a9a" type="flat">{{
				$t("cancel")
			}}</vs-custom-button>
		</div>
	</vs-popup>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";

export default {
	name: "RefundPopup",
	mixins: [databaseManager],
	props: {
		active: { default: false, type: Boolean },
		recommendedPrice: { default: 0 }
	},
	data() {
		return {
			reason: null,
			failReasons: [],
      reward: 0,
		};
	},
	watch: {
		activeProp(newValue) {
			if (newValue === false) {
				this.reason = null;
				this.reward = 0;
			}
		}
	},
	computed: {
    isReward() {
      return isNaN(this.reward) || !(this.reward > 0)
    },
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		},
		enabledFailReasons() {
			return this.failReasons.filter(item => item.enabled === 1);
		}
	},
	methods: {
		confirm() {
			if (this.reason === null) return;
			this.$emit("confirm", this.reason, this.reward);
			this.activeProp = false;
		},
		close() {
			this.activeProp = false;
		}
	},
	async mounted() {
		this.failReasons = await this.dbGetReturnReasons();
	}
};
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.set-ticket-failed {
	&__title {
		padding-left: 8px;
		padding-right: 8px;
	}

	&__list {
		padding-left: 8px;
		padding-right: 8px;
		margin-top: 7px;
	}

	&__item {
		margin-top: 5px;
	}

	&__controls {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.vs-popup {
		max-width: 450px !important;
		width: 100% !important;
		padding: 0;

		&--content {
			width: 100%;
			height: 100%;
		}

		&--close,
		&--title h3 {
			color: $primary;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
	}
	.reward-input {
		width: 100%;
	}
}
</style>
